module.exports = __webpack_public_path__ + "static/promo_1-dba4464a07aad2ac9ebd11c729b467f6.png";